import { size } from 'lodash'

import regex from 'helpers/formatters/regex'
import cnpj from 'helpers/validates/cnpj'
import cpf from 'helpers/validates/cpf'

const isValid = (value) => {
  const sanitizedValue = regex.onlyNumbersAndLetters(value)

  if (size(sanitizedValue) > 11 || regex.hasLetters(sanitizedValue)) {
    return cnpj.isValid(sanitizedValue)
  }

  return cpf.isValid(sanitizedValue)
}

const cpfOrCnpj = { isValid }

export default cpfOrCnpj
